import moment from 'moment';

/**
 * Receives a `Date` object and returns
 * a new one with an extra day added.
 *
 * If no `date` parameter is passed, it will take today's date
 * and return tomorrow's date. */
function addOneDay(date?: Date): Date {
  return moment(date)
    .add(1, 'days')
    .toDate();
}

export default addOneDay;
